<style lang="stylus" scoped>
    .advancevip-modal
        /deep/.pcstyleModal-header
            .pcstyleModal-header-text
                font-size 14px !important
        /deep/.pcstyleModal-content
            padding 0 !important
        .advancevip-content
            padding 16px 24px 24px 24px
            .advancevip-text
                font-size 14px !important
                line-height 22px
                color #222 !important
                margin-bottom 16px
            .advancevip-btn
                float right
                min-width 91px
                height 28px
                display flex
                justify-content center
                align-items center
                padding 6px 24px 6px 24px
                border-radius 6px
                background linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
                cursor pointer
                font-size 12px
                color #402300
                margin-top 8px
                &:hover
                    background linear-gradient(0deg, rgba(255,255,255,0.25), rgba(255,255,255,0.25)), linear-gradient(90deg, #ffef92 0%, #ffd67b 100%)
</style>

<template>
    <EDModal class="advancevip-modal" ref="modal">
        <div class="advancevip-content">
            <p class="advancevip-text">{{ $t("tip1") }}</p>
            <p class="advancevip-text">{{ $t("tip2") }}</p>
            <div class="advancevip-btn" @click="toVip">{{ $t("vipbtn") }}</div>
        </div>
    </EDModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class AdvanceVip extends Vue {
        toVip() {
            this.$openBuyPage();
        }
        created() {}
        mounted() {
            let dom = this.$refs.modal as any;
            dom.show({
                width: 480,
                title: this.$t("title"),
                closeEvent: () => {
                    this.$emit("closeModal");
                },
            });
        }
    }
</script>
<i18n>
{
    "zh": {
        "title": "免费版提示",
        "tip1": "此文件已使用会员特权，下次用免费版亿图图示访问此文件仅能浏览，不能编辑噢。",
        "tip2": "开通VIP可享受无限编辑，并尊享30+特权。",
        "vipbtn": "开通VIP"
    },
    "en": {
        "title": "Reminder for Free Version Users",
        "tip1": "Premium benefits were used for this file. Please note that EdrawMax free version users can only view this file and cannot edit it next time.",
        "tip2": "Premiums can enjoy unlimited editing and 30+ benefits.",
        "vipbtn": "Buy now"
    },
    "fr": {
        "title": "Rappel pour les utilisateurs de la version gratuite",
        "tip1": "Les avantages Premium ont été utilisés pour ce fichier. Les utilisateurs de la version gratuite d'EdrawMax peuvent afficher ce fichier mais pas le modifier.",
        "tip2": "La version Premium offre une édition illimitée et plus de 30 avantages.",
        "vipbtn": "Acheter maintenant"
    },
    "de": {
        "title": "Erinnerung für Benutzer der kostenlosen Version",
        "tip1": "Für diese Datei wurden Premium-Vorteile verwendet. Bitte beachten Sie, dass Benutzer der kostenlosen EdrawMax-Version diese Datei nur anzeigen und nicht bearbeiten können.",
        "tip2": "Premium-Benutzer haben unbegrenzte Bearbeitungsfreiheit und profitieren von über 30 Vorteilen.",
        "vipbtn": "Jetzt kaufen"
    },
    "jp": {
        "title": "無料版ユーザーへのリマインダー",
        "tip1": "このファイルにはプレミアム特典が使用されています。EdrawMaxの無料版ユーザーはこのファイルを表示できますが、編集はできません。",
        "tip2": "プレミアムメンバーは制限なしの編集機能と30種類以上の特典をご利用いただけます。",
        "vipbtn": "今すぐ購入"
    },
    "es": {
        "title": "Recordatorio para los usuarios de la versión gratuita",
        "tip1": "Se han utilizado ventajas Premium para este archivo. Recuerda que los usuarios de la versión gratuita de EdrawMax no pueden editar este archivo, solo pueden verlo.",
        "tip2": "Los miembros Premium disfrutan de edición ilimitada y más de 30 ventajas.",
        "vipbtn": "Comprar ahora"
    },
    "pt": {
        "title": "Lembrete para usuários da versão gratuita",
        "tip1": "Benefícios premium foram usados para este arquivo. Observe que os usuários da versão gratuita do EdrawMax podem apenas visualizar este arquivo e não podem editá-lo.",
        "tip2": "Usuários premium podem desfrutar de edição ilimitada e mais de 30 benefícios.",
        "vipbtn": "Comprar agora"
    },
    "it": {
        "title": "Promemoria per gli utenti della versione gratuita",
        "tip1": "Sono stati utilizzati vantaggi Premium per questo file. Tieni presente che gli utenti della versione gratuita di EdrawMax possono solo visualizzare questo file e non possono modificarlo.",
        "tip2": "Gli utenti Premium possono usufruire di una modifica illimitata e di oltre 30 vantaggi.",
        "vipbtn": "Acquista ora"
    },
    "tw": {
        "title": "免費版本使用者提示",
        "tip1": "此檔案已使用 Premium 權益。請注意，EdrawMax 免費版本使用者只能檢視此檔案，無法進行編輯。",
        "tip2": "Premium 使用者可享有無限編輯權限，以及超過 30 個權益。",
        "vipbtn": "立即購買"
    },
    "kr": {
        "title": "무료 버전 사용자를 위한 알림",
        "tip1": "이 파일에 프리미엄 혜택이 사용되었습니다. EdrawMax 무료 버전 사용자는 이 파일을 볼 수만 있으며 편집할 수 없습니다.",
        "tip2": "프리미엄은 무제한 편집과 30가지 이상의 혜택을 누릴 수 있습니다.",
        "vipbtn": "지금 구매하기"
    }
}
</i18n>
